import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import useUniqueId from "../../../Hooks/useUniqueId";
import DateService from "../../../../Services/Shared/Date.service";
import Attachment from "../../../Presentational/Attachment/Attachment";
import InfoItems from "../../../UI/InfoItems/InfoItems";
import BooleanDisplay from "../../../UI/BooleanDisplay/BooleanDisplay";
import ListService from "../../../../Services/Shared/List.service";
const MessageScheduledDetailInfo = ({ scheduledMessage, caseloadPeople, }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const makeId = useUniqueId()[1];
    const isActive = ((_a = scheduledMessage === null || scheduledMessage === void 0 ? void 0 : scheduledMessage.scheduledMessage) === null || _a === void 0 ? void 0 : _a.active) || false;
    const renderEmailType = () => {
        if (scheduledMessage.scheduledMessage.sendToInstitutionalEmail &&
            scheduledMessage.scheduledMessage.sendToPersonalEmail) {
            return "Both Personal and Institutional";
        }
        return scheduledMessage.scheduledMessage.sendToPersonalEmail
            ? "Personal"
            : "Institutional";
    };
    const renderSchedule = () => {
        if (scheduledMessage.scheduledMessage.automatedSchedule.interval === 0) {
            return "One-Time Send";
        }
        const isDaySingular = scheduledMessage.scheduledMessage.automatedSchedule.interval === 1;
        return `Every ${isDaySingular
            ? "day"
            : scheduledMessage.scheduledMessage.automatedSchedule.interval + " days"} at ${DateService.displayJustTime(new Date(scheduledMessage.scheduledMessage.nextExecutionDate))}`;
    };
    return (_jsxs(_Fragment, { children: [_jsx("h1", { children: scheduledMessage.scheduledMessage.name }), _jsx("div", { className: "mb-2", children: _jsx("span", { className: `badge badge-${isActive ? "success" : "secondary"}`, children: isActive ? "Active" : "Inactive" }) }), _jsx(InfoItems, { items: [
                    {
                        label: "Filter",
                        value: (_jsxs(_Fragment, { children: [_jsx("span", { className: ((_b = scheduledMessage.scheduledMessage.population) === null || _b === void 0 ? void 0 : _b.fontAwesomeIcon) + " mr-1", "aria-hidden": "true" }), (_c = scheduledMessage.scheduledMessage.population) === null || _c === void 0 ? void 0 : _c.name] })),
                    },
                    {
                        label: "Limited To User's Caseload",
                        value: ((_e = (_d = scheduledMessage.scheduledMessage) === null || _d === void 0 ? void 0 : _d.population) === null || _e === void 0 ? void 0 : _e.adHoc) ? (_jsx(_Fragment, { children: ListService.displayWithCommasAndAnd(caseloadPeople.map((person) => person.fullName)) })) : null,
                    },
                    {
                        label: "Delivery Method",
                        value: scheduledMessage.scheduledMessage.isSms ? "SMS" : "Email",
                    },
                    {
                        label: "Email Type",
                        value: renderEmailType(),
                    },
                    {
                        label: "Schedule",
                        value: renderSchedule(),
                    },
                    {
                        label: "Logged",
                        value: (_jsx(BooleanDisplay, { val: scheduledMessage.scheduledMessage.logged })),
                    },
                ] }), _jsx("div", { className: "row", children: _jsxs("div", { className: "col", children: [_jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: makeId("subject"), className: "mb-0", children: "Subject" }), _jsx("div", { id: makeId("subject"), children: scheduledMessage.messageTemplate.subject })] }), _jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: makeId("body"), className: "mb-0", children: "Body" }), _jsx("div", { id: makeId("body"), className: "card card-body" // eslint-disable-next-line react/no-danger
                                    , dangerouslySetInnerHTML: {
                                        __html: ((_f = scheduledMessage.scheduledMessage.messageTemplate) === null || _f === void 0 ? void 0 : _f.body) || "",
                                    } })] }), ((_g = scheduledMessage.scheduledMessage.attachments) === null || _g === void 0 ? void 0 : _g.length) !== 0 && (_jsxs("div", { className: "form-group", children: [_jsx("label", { htmlFor: makeId("attachments"), className: "mb-0", children: "Attachments" }), _jsx("div", { id: makeId("attachments"), className: "d-flex flex-wrap", children: (_h = scheduledMessage.scheduledMessage.attachments) === null || _h === void 0 ? void 0 : _h.map((attachment) => (_jsx(Attachment, { attachment: attachment, className: "mb-3 mr-3" }, attachment.attachmentId))) })] }))] }) })] }));
};
export default MessageScheduledDetailInfo;
